
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/design-system/page/[id]",
      function () {
        return require("private-next-pages/cases/design-system/page/[id].tsx");
      }
    ]);
  